import { AppBar, Tab, Tabs, Toolbar, useTheme, useMediaQuery, Box } from '@mui/material';
import DrawerComp from './DrawerComp.js';
import { Link } from 'react-router-dom';

const Header = () => {
  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down('md'));
  const isMobileSmall = useMediaQuery(theme.breakpoints.down('sm'));

  const PAGES = ["Home", "About", "Services", "Contact"];

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: '#F5F5F5',
        padding: { xs: '15px 0', sm: '20px 0', md: '30px 0' },
        paddingLeft: { xs: '10px', sm: '25px', md: '50px' },
        paddingBottom: { xs: '2rem', sm: '3rem', md: '5rem' },
        boxShadow: 'none'
      }}
    >
      <Toolbar
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: isMatch ? 'space-between' : 'space-between',
          flexDirection: { xs: 'column', sm: 'row' }
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: { xs: isMobileSmall ? '1rem' : '0', sm: '0' }
          }}
        >
          {/* Logo Link to Home - Enhanced */}
          <Link
            to="/"
            style={{
              textDecoration: 'none',
              display: 'block',
              padding: '8px'  // Add padding for larger touch target
            }}
          >
            <Box
              component="img"
              src="/logo.jpg"
              alt="Nicole Hahn Design Logo"
              sx={{
                width: { xs: 100, sm: 120, md: 170 },  // Increased size
                height: 'auto',  // Keep aspect ratio
                mb: 1,
                cursor: 'pointer',
                transition: 'transform 0.2s',  // Smooth hover effect
                '&:hover': {
                  transform: 'scale(1.05)'  // Slight grow on hover
                }
              }}
            />
          </Link>
          {/* Brand Name */}
        </Box>

        {/* Navigation Menu or Drawer */}
        {isMatch ? (
          <Box sx={{
            alignSelf: { xs: 'flex-end', sm: 'center' },
            position: { xs: 'absolute', sm: 'relative' },
            top: { xs: '15px', sm: 'auto' },
            right: { xs: '15px', sm: 'auto' }
          }}>
            <DrawerComp />
          </Box>
        ) : (
          <Box sx={{ display: 'flex', marginLeft: 'auto' }}>
            <Tabs
              textColor="inherit"
              indicatorColor="secondary"
              sx={{
                '& .MuiTabs-flexContainer': { gap: { xs: '10px', sm: '15px', md: '20px' } }
              }}
            >
              {PAGES.map((page, index) => (
                <Tab
                  key={index}
                  label={page}
                  component={Link}
                  to={page === "Home" ? "/" : `/${page.toLowerCase()}`}
                  sx={{
                    color: 'black',
                    fontSize: { xs: '1.2rem', sm: '1.3rem', md: '1.5rem' },
                    fontWeight: 500,
                    textTransform: 'uppercase',
                    transition: 'color 0.3s ease',
                    padding: { xs: '6px 8px', md: '12px 16px' },
                    minWidth: { xs: 'auto', md: '90px' },
                    '&:hover': { color: '#888' }
                  }}
                />
              ))}
            </Tabs>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;